import { useVcosole } from '@hooks/useVconsole'


import AppRoutes from '@/router'

export default function App() {
  const [vc] = useVcosole()
  useEffect(() => {
    console.log('VConsole ?', vc)
    if (vc) {
      vc.show()
    }
  }, [])
  return (
    <div>
      <AppRoutes />
    </div>
  )
}
